import { render, staticRenderFns } from "./StudyTreeInfo.vue?vue&type=template&id=493fb126&scoped=true&"
import script from "./StudyTreeInfo.vue?vue&type=script&lang=js&"
export * from "./StudyTreeInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudyTreeInfo.vue?vue&type=style&index=0&id=493fb126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493fb126",
  null
  
)

export default component.exports